import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

// Generate PDF from a DOM element
export const generatePdfFromElement = async (element, fileName = 'download', options = {}) => {
  try {
    // Call loading start callback if provided
    if (options.onLoadingStart) {
      options.onLoadingStart();
    }

    // Log the element for debugging purposes
    console.log('Generating PDF from element:', element);

    if (!element) {
      throw new Error('Element to convert to PDF is not defined');
    }

    // Configure html2canvas options for better quality
    const canvas = await html2canvas(element, {
      scale: 2, // Higher scale for better quality
      useCORS: true,
      logging: false,
      allowTaint: true,
      backgroundColor: '#ffffff'
    });

    const imgData = canvas.toDataURL('image/png');
    
    // Calculate dimensions
    const imgWidth = 210; // A4 width in mm (portrait)
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    // Create PDF
    const pdf = new jsPDF('p', 'mm', 'a4');
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Add more pages if the content is longer than one page
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Save the PDF
    pdf.save(`${fileName}.pdf`);

    // Call completion callback if provided
    if (options.onLoadingComplete) {
      options.onLoadingComplete();
    }

    return true;
  } catch (error) {
    console.error('Error generating PDF:', error);
    
    // Call error callback if provided
    if (options.onError) {
      options.onError(error);
    }
    
    throw error;
  }
};

// Format currency for reports
export const formatCurrencyForReport = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(amount || 0);
};

// Format date for reports
export const formatDateForReport = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};
